export enum LoginSteps {
  LoginForm = "LoginForm",
  VerifyOtp = "VerifyOtp",
}
